import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Question } from 'app/models/form';
import { AppFormComponent } from 'app/modules/app-form/form-test/app-form.component';

@Component({
  selector: 'app-report-parameters-detail',
  templateUrl: './report-parameters-detail.component.html',
  styleUrls: ['./report-parameters-detail.component.scss']
})
export class ReportParametersDetailComponent implements OnInit {

  @ViewChild('specialParamsForm') specialParamsForm: AppFormComponent;

  requestedParameters:string[] = [""];
  specialParameters: Question[] = [];
  tableMock: Question;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { requestedParams:string, specialParameters: Question[]},
    public dialogRef: MatDialogRef<ReportParametersDetailComponent>,
  ) { 
  }

  ngOnInit(): void {
    // console.log(this.data);
    this.tableMock = {
      answer: 
      "{\"value\":[{\"Q06-1\":\" eee\",\"Q06-2\":\" --- \",\"Q06-3\":\" ee\",\"Q06-4\":\" --- \"},{\"Q06-1\":\" aaa\",\"Q06-2\":\" aaa\",\"Q06-3\":\"---\",\"Q06-4\":\"---\"}]}", 
      // "{\"value\":[{\"Q06-1\":\" PPPP\",\"Q06-2\":\"  MMM\",\"Q06-3\":\"---\",\"Q06-4\":\"---\"}]}",
      answerFiles: [],
      answerId:5407,
      attachAllowed: true,
      attachRequired: false,
      attachments:[],
      code: "Q06",
      commentAllowed: true,
      commentRequired:false,
      comments:[],
      conditionalGroup: null,
      description:"Involucrados",
      detail: "En esta sección podrá ingresar más de un involucrado, especificando información de cada uno. Utilice los botones 'Agregar Involucrado' y 'Eliminar' para agregar o eliminar personas.",
      dimensions: [
        {id: 1, code: "Q06-1", description: "Nombre del involucrado"}, 
        {id: 2, code: "Q06-2", description: "Relación con la organización"},
        {id: 3, code: "Q06-3", description: "Cargo del involucrado"},
        {id: 4, code: "Q06-4", description: "Subsidiaria "}],
      dynamicFilterOperator:null,
      id: 6,
      isRequired: true,
      orderPosition: 6,
      possibleAnswers: [],
      questionGroup: null,
      questionGroupId:null,
      questionTypeId:8,
      templateFileId:null,
    };
    
    if(this.data?.requestedParams?.includes('||')){
      // MOCK:
      // this.dat.requestedParamsa += 'Nomina Invitados [Nombre Autorizado:  Ricardo|Apellido Autorizado:  FF|Lorem:Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur doloribus eaque similique debitis, quas maiores adipisci veritatis in commodi velit nihil voluptatibus, repellendus officia sapiente, id eum autem non accusantium.|Lorem:Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur doloribus eaque similique debitis, quas maiores adipisci veritatis in commodi velit nihil voluptatibus, repellendus officia sapiente, id eum autem non accusantium.|Lorem:Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur doloribus eaque similique debitis, quas maiores adipisci veritatis in commodi velit nihil voluptatibus, repellendus officia sapiente, id eum autem non accusantium.|Lorem:Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur doloribus eaque similique debitis, quas maiores adipisci veritatis in commodi velit nihil voluptatibus, repellendus officia sapiente, id eum autem non accusantium.]';
      // this.data += '||Prueba [Abuso de poder|Acoso sexual|Abuso de poder|Acoso sexual|Abuso de poder|Acoso sexual|Abuso de poder|Acoso sexual|Abuso de poder|Acoso sexual]'
      // this.data += '||Involucrados [Nombre del involucrado:  eeee, rrsasdarr, sadasdasdasd|Relación con la organización:  eeasdbasj ashdkas  askdask jaskja s asdask  sadasdas as das ssss|Cargo del involucrado:  eeeeeeeeee eeee|Subsidiaria :  eee]'
      setTimeout(() => this.requestedParameters = this.data?.requestedParams?.split('||'), 200);
    }else{
      setTimeout(() => this.requestedParameters = [this.data?.requestedParams], 200);
    }

    if(this.data.specialParameters.length > 0){
      setTimeout(() => this.specialParameters = this.data.specialParameters, 200);
    }

    if(document.getElementById('params-detail-container')?.parentElement?.parentElement){
      document.getElementById('params-detail-container').parentElement.parentElement.style.padding = '0px';
    }
  }

  onClose(){
    this.dialogRef.close();
  }
}
